import CustomModal from '@/components/CustomModal';
import styles from './index.less';

export default function CumulativeIncomeModal({ visible, onClose, summaryData }) {
  return (
    <CustomModal visible={visible} okCallback={onClose} title="">
      <div className={styles.cumulativeIncomeModal}>
        <div className={styles.totalIncome}>
          <div className={styles.label}>累计收益/元</div>
          <div className={styles.amount}>{summaryData?.ti}</div>
        </div>
        <div className={styles.incomeDetail}>
          <div className={styles.item}>
            <div className={styles.label}>累计云豆/100</div>
            <div className={styles.value}>{summaryData?.ticb}/100</div>
          </div>
          {summaryData?.tic > 0 ? (
            <>
              <div className={styles.plusIcon}></div>
              <div className={styles.item}>
                <div className={styles.label}>累计现金/元</div>
                <div className={styles.value}>{summaryData?.tic}</div>
              </div>
            </>
          ) : (
            <>
              <div className={styles.divider}></div>
              <div className={styles.intro}>已按 100 云豆: 1 元换算成累计收益</div>
            </>
          )}
        </div>
        <div className={styles.tips}>
          <div className={styles.tipsTitle}>温馨提示：</div>
          <p className={styles.tipsInfo}>
            1、累计收益为您账号下在网心云累计所获得的云豆与现金。计算方式如上。
          </p>
          <p className={styles.tipsInfo}>
            2、自2025年11月15日起，为方便查阅，云豆兑换后入账的现金不纳入【累计现金】的统计。
          </p>
          {summaryData?.hc2c && (
            <p className={styles.tipsInfo}>
              3、您2024年4月1日至2024年11月15日期间云豆兑换的现金{summaryData?.hc2c}
              元已从【累计现金】中剔除。故APP新旧版本对比可能存在因统计方式不同展示不一致的情况，但实际收入未变化。若有疑问可联系客服。
            </p>
          )}
        </div>
      </div>
    </CustomModal>
  );
}
